import axios from "axios";

export const deleteNotiById = async (id) => {
  try {
    const response = await axios.delete(`http://localhost:8080/webnet-hms/api/notifications/${id}`);
    window.alert("Notifications deleted successfully!");
    return response.data;
  } catch (error) {
    console.error("Error deleting Notifications:", error);
    window.alert("Failed to delete Notifications.");
  }
};
